import { Component, OnInit } from "@angular/core";
import { IntegratedAdmissionPreWizardService } from "../service/integrated-admission-pre.wizard.service";
import { IntegratedAdmissionWizardService } from "../service/integrated-admission-wizard.service";
import { InvoiceCashDeskService } from "src/app/services/invoice-cash-desk/invoice-cash-desk.service";
import { InvoiceIntegratedAdmissionCashDeskService } from "src/app/services/invoice-cash-desk/invoice-integrated-admission-cash-desk.service";
import { MenuService } from "src/app/services/menu.service";

@Component({
  selector: "app-integrated-pre-admission-wizard",
  providers: [
    {
      provide: IntegratedAdmissionWizardService,
      useClass: IntegratedAdmissionPreWizardService,
    },
    {
      provide: InvoiceCashDeskService,
      useClass: InvoiceIntegratedAdmissionCashDeskService,
    },
  ],
  templateUrl: "./integrated-pre-admission-wizard.component.html",
  styleUrls: ["./integrated-pre-admission-wizard.component.css"],
})
export class IntegratedPreAdmissionWizardComponent implements OnInit {
  constructor( private menuService: MenuService ) {
    this.menuService.setMenuTitle("Recepción", "previa integrada");
  }

  ngOnInit() {}
}
